/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Division hooks barrel export
 */

export { useDivision, type DivisionState } from "./use-division";
export {
  useDivisionRoster,
  type RosterMember,
  type RosterState,
  type DivisionRole,
} from "./use-division-roster";
export {
  useDivisionBudgets,
  type DivisionBudget,
  type DivisionBudgetsState,
} from "./use-division-budgets";
export { useCurrentUserDivision } from "./use-current-user-division";
export {
  useDivisionMetrics,
  type DivisionMetricsSummary,
  type MonthlyTrendEntry,
  type DivisionMetricsData,
} from "./use-division-metrics";
